<script setup lang="ts">
import AdminHeader from './AdminHeader.vue'
import AdminSidebar from './AdminSidebar.vue'
</script>

<template>
  <div class="admin-layout">
    <AdminHeader class="admin-layout__header" />
    <div class="admin-layout__body">
      <AdminSidebar class="admin-layout__sidebar" />
      <main class="admin-layout__main">
        <div class="admin-layout__content">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped lang="scss">
.admin-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;

  &__header {
    flex-shrink: 0;
    height: 56px;
    z-index: 100;
  }

  &__body {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  &__sidebar {
    flex-shrink: 0;
    width: 220px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &__main {
    flex: 1;
    overflow: auto;
    background-color: var(--aw-bg-subtle);
  }

  &__content {
    padding: var(--aw-space-6);
    min-height: 100%;
  }
}
</style>
